[
  {
    "parentName": "Altice France",
    "code": "ALRT",
    "name": "Agglo La Rochelle THD"
  },
  {
    "parentName": "Altice France",
    "code": "CNCT",
    "name": "Connect 76"
  },
  {
    "parentName": "Altice France",
    "code": "CORF",
    "name": "Corsica Fibra"
  },
  {
    "parentName": "Altice France",
    "code": "CO92",
    "name": "Xpfibre 92"
  },
  {
    "parentName": "Altice France",
    "code": "DETE",
    "name": "Debitex Telecom"
  },
  {
    "parentName": "Altice France",
    "code": "ENTH",
    "name": "Essonne numérique Très Haut Débit"
  },
  {
    "parentName": "Altice France",
    "code": "EULH",
    "name": "Eure et Loir THD"
  },
  {
    "parentName": "Altice France",
    "code": "GUDI",
    "name": "Guadeloupe Digital"
  },
  {
    "parentName": "Altice France",
    "code": "DSPT",
    "name": "Hérault THD"
  },
  {
    "parentName": "Altice France",
    "code": "ISER",
    "name": "Isère Fibre"
  },
  {
    "parentName": "Altice France",
    "code": "LOFI",
    "name": "Loiret Fibre"
  },
  {
    "parentName": "Altice France",
    "code": "LOIR",
    "name": "Loiret THD"
  },
  {
    "parentName": "Altice France",
    "code": "MART",
    "name": "Martinique THD"
  },
  {
    "parentName": "Altice France",
    "code": "COAG",
    "name": "MEL THD"
  },
  {
    "parentName": "Altice France",
    "code": "ONUM",
    "name": "Oise Numérique"
  },
  {
    "parentName": "Altice France",
    "code": "OPTE",
    "name": "Opalys Telecom"
  },
  {
    "parentName": "Altice France",
    "code": "OUTR",
    "name": "Outremer Telecom"
  },
  {
    "parentName": "Altice France",
    "code": "DSDH",
    "name": "Saône et Loire THD"
  },
  {
    "parentName": "Altice France",
    "code": "DSP3",
    "name": "Savoie Connectée"
  },
  {
    "parentName": "Altice France",
    "code": "SMTH",
    "name": "Seine-et-Marne THD"
  },
  {
    "parentName": "Altice France",
    "code": "NURC",
    "name": "SFR Fibre SAS"
  },
  {
    "parentName": "Altice France",
    "code": "SFR0",
    "name": "Société Française du Radiotéléphone (SFR)"
  },
  {
    "parentName": "Altice France",
    "code": "SRR",
    "name": "Societe Reunionnaise du Radiotelephone (SRR)"
  },
  {
    "parentName": "Altice France",
    "code": "TARN",
    "name": "Tarn Fibre"
  },
  {
    "parentName": "Altice France",
    "code": "THDD",
    "name": "THD64"
  },
  {
    "parentName": "Altice France",
    "code": "VCMB",
    "name": "Vallée de Chamonix Mont-Blanc connectée"
  },
  {
    "parentName": "Altice France",
    "code": "VALO",
    "name": "Valofibre"
  },
  {
    "parentName": "Altice France",
    "code": "WIGA",
    "name": "Wigard"
  },
  {
    "parentName": "Altice France",
    "code": "TUMO",
    "name": "Xp Fibre Moulin-les-Metz"
  },
  {
    "parentName": "Altice France",
    "code": "SFTT",
    "name": "Xp Fibre - SFMD"
  },
  {
    "parentName": "Altice France",
    "code": "SFTT",
    "name": "Xp Fibre - SFOR"
  },
  {
    "parentName": "Altitude Infra",
    "code": "AF21",
    "name": "Corai"
  },
  {
    "parentName": "Altitude Infra",
    "code": "DSP1",
    "name": "Altitude Infra Calvados"
  },
  {
    "parentName": "Altitude Infra",
    "code": "TUTO",
    "name": "Altitude Infra Côte Fleurie"
  },
  {
    "parentName": "Altitude Infra",
    "code": "BART",
    "name": "Altitude Infra Dunkerque Grand Littoral"
  },
  {
    "parentName": "Altitude Infra",
    "code": "TUHS",
    "name": "Altitude Infra Haute-Savoie"
  },
  {
    "parentName": "Altitude Infra",
    "code": "TTNY",
    "name": "Altitude Infra Nancy"
  },
  {
    "parentName": "Altitude Infra",
    "code": "SMSM",
    "name": "Altitude Infra Somme"
  },
  {
    "parentName": "Altitude Infra",
    "code": "MENI",
    "name": "Dioptic by Altitude Infra"
  },
  {
    "parentName": "Altitude Infra",
    "code": "EMER",
    "name": "Emeraude THD"
  },
  {
    "parentName": "Altitude Infra",
    "code": "TEES",
    "name": "Europ'Essonne by Altitude Infra"
  },
  {
    "parentName": "Altitude Infra",
    "code": "GRNE",
    "name": "Altitude Infra Gravelines"
  },
  {
    "parentName": "Altitude Infra",
    "code": "FI31",
    "name": "La Fibre 31"
  },
  {
    "parentName": "Altitude Infra",
    "code": "LOSA",
    "name": "Losange Fibre"
  },
  {
    "parentName": "Altitude Infra",
    "code": "MAFI",
    "name": "Manche Fibre"
  },
  {
    "parentName": "Altitude Infra",
    "code": "OCFI",
    "name": "Octogone Fibre"
  },
  {
    "parentName": "Altitude Infra",
    "code": "NIED",
    "name": "OXYGENE"
  },
  {
    "parentName": "Altitude Infra",
    "code": "AF40",
    "name": "Pixl Fibre"
  },
  {
    "parentName": "Altitude Infra",
    "code": "JURA",
    "name": "Prisme Fibre"
  },
  {
    "parentName": "Altitude Infra",
    "code": "NETP",
    "name": "Resoptic"
  },
  {
    "parentName": "Altitude Infra",
    "code": "ROSA",
    "name": "Rosace Fibre"
  },
  {
    "parentName": "Altitude Infra",
    "code": "SETR",
    "name": "Seine Essonne THD by Altitude Infra"
  },
  {
    "parentName": "Altitude Infra",
    "code": "SETE",
    "name": "Sequantic Telecom"
  },
  {
    "parentName": "Altitude Infra",
    "code": "THD6",
    "name": "THD 06"
  },
  {
    "parentName": "Altitude Infra",
    "code": "HD66",
    "name": "THD66"
  },
  {
    "parentName": "Altitude Infra",
    "code": "VANN",
    "name": "Vannes Agglo Numérique"
  },
  {
    "parentName": "Altitude Infra",
    "code": "RTHD",
    "name": "Vendée Numérique"
  },
  {
    "parentName": "Altitude Infra",
    "code": "YCNK",
    "name": "YCONIK FIBRE"
  },
  {
    "parentName": "Altitude Infra",
    "code": "GLCS",
    "name": "Glaucos"
  },
  {
    "parentName": "Axione",
    "code": "ADTI",
    "name": "ADTIM"
  },
  {
    "parentName": "Axione",
    "code": "ADTH",
    "name": "ADTIM FttH"
  },
  {
    "parentName": "Axione",
    "code": "AISN",
    "name": "Aisne THD"
  },
  {
    "parentName": "Axione",
    "code": "BEFO",
    "name": "Berry Fibre Optique"
  },
  {
    "parentName": "Axione",
    "code": "EURE",
    "name": "Eure Normandie THD"
  },
  {
    "parentName": "Axione",
    "code": "GOTE",
    "name": "Go Telecom"
  },
  {
    "parentName": "Axione",
    "code": "LFPA",
    "name": "La fibre Paloise"
  },
  {
    "parentName": "Axione",
    "code": "NIVE",
    "name": "Nivertel"
  },
  {
    "parentName": "Axione",
    "code": "LFNA",
    "name": "Nouvelle-Aquitaine THD"
  },
  {
    "parentName": "Axione",
    "code": "LETR",
    "name": "Sartel THD"
  },
  {
    "parentName": "Axione",
    "code": "THD4",
    "name": "THD42 Exploitation (SIEL)"
  },
  {
    "parentName": "Axione",
    "code": "THD5",
    "name": "THD 59-62"
  },
  {
    "parentName": "Axione",
    "code": "VANU",
    "name": "Vaucluse Numérique"
  },
  {
    "parentName": "Axione",
    "code": "FI44",
    "name": "Fibre44"
  },
  {
    "parentName": "Axione",
    "code": "LOAN",
    "name": "Fibre44"
  },
  {
    "parentName": "Orange",
    "code": "FRTE",
    "name": "Orange"
  },
  {
    "parentName": "Orange",
    "code": "GERS",
    "name": "Gers numérique"
  },
  {
    "parentName": "Orange Concessions",
    "code": "AXTD",
    "name": "Alliance Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "ARTD",
    "name": "Ariège Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "ATHD",
    "name": "Auvergne Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "BFCF",
    "name": "BFC Fibre"
  },
  {
    "parentName": "Orange Concessions",
    "code": "CAPS",
    "name": "CAPS Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "CMTD",
    "name": "Charente-Maritime Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "SY79",
    "name": "Deux-Sèvres Numérique"
  },
  {
    "parentName": "Orange Concessions",
    "code": "GTHD",
    "name": "Gironde Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "GDHD",
    "name": "Grand Dax Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "HASF",
    "name": "Haute-Saône Fibre"
  },
  {
    "parentName": "Orange Concessions",
    "code": "KOUR",
    "name": "Kourou Fibre"
  },
  {
    "parentName": "Orange Concessions",
    "code": "LTHD",
    "name": "Laval THD"
  },
  {
    "parentName": "Orange Concessions",
    "code": "MAYE",
    "name": "Mayenne Fibre"
  },
  {
    "parentName": "Orange Concessions",
    "code": "MONU",
    "name": "Moselle Numérique"
  },
  {
    "parentName": "Orange Concessions",
    "code": "OMTD",
    "name": "Orne Département Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "RRTH",
    "name": "Régie Réunion THD"
  },
  {
    "parentName": "Orange Concessions",
    "code": "THDB",
    "name": "THD Bretagne"
  },
  {
    "parentName": "Orange Concessions",
    "code": "ENEZ",
    "name": "Enez Fibre"
  },
  {
    "parentName": "Orange Concessions",
    "code": "VTHD",
    "name": "Var Très Haut Débit"
  },
  {
    "parentName": "Orange Concessions",
    "code": "VIEN",
    "name": "Régie Vienne Numérique"
  },
  {
    "parentName": "Orange Concessions",
    "code": "YANA",
    "name": "Yana Fibre"
  },
  {
    "parentName": "Lumière",
    "code": "ANFI",
    "name": "Anjou Fibre"
  },
  {
    "parentName": "Lumière",
    "code": "VDLF",
    "name": "Val de Loire Fibre"
  },
  {
    "parentName": "Lumière",
    "code": "VOFI",
    "name": "Val d'Oise Fibre"
  },
  {
    "parentName": "Lumière",
    "code": "YVFI",
    "name": "Yvelines Fibre"
  },
  {
    "parentName": "Lumière",
    "code": "FAGL",
    "name": "Faucigny Glières Fibre"
  },
  {
    "parentName": "Océinde",
    "code": "MAYT",
    "name": "Mayotte THD"
  },
  {
    "parentName": "Océinde",
    "code": "REUN",
    "name": "Réunicable SAS"
  },
  {
    "parentName": null,
    "code": "CMIN",
    "name": "Chartres Métropole Innovations Numériques (CM'IN)"
  },
  {
    "parentName": null,
    "code": "DAUF",
    "name": "Dauphin Telecom"
  },
  {
    "parentName": null,
    "code": "GUYA",
    "name": "Guyacom"
  },
  {
    "parentName": null,
    "code": "THDT",
    "name": "THD Tel"
  },
  {
    "parentName": null,
    "code": "FREE",
    "name": "Réseau Optique de France"
  },
  {
    "parentName": null,
    "code": "NEYO",
    "name": "Net And You"
  },
  {
    "parentName": null,
    "code": "OTHD",
    "name": "Orne THD"
  },
  {
    "parentName": null,
    "code": "CSBY",
    "name": "St-Barth Digital"
  },
  {
    "parentName": null,
    "code": "CCPB",
    "name": "Communauté de communes du Pays de Bitche"
  },
  {
    "parentName": null,
    "code": "FAFO",
    "name": "Fibragglo"
  },
  {
    "parentName": null,
    "code": "FIBR",
    "name": "Fibreso"
  },
  {
    "parentName": null,
    "code": "REFO",
    "name": "Régie d'Exploitation de la Fibre Optique de Saint-Quentin-en-Yvelines (Quentiop)"
  },
  {
    "parentName": null,
    "code": "REFH",
    "name": "Regie fibre optique de Falck et Hargarten"
  },
  {
    "parentName": null,
    "code": "GAZE",
    "name": "Régie gaz et électricité de Sallanches (RGES)"
  },
  {
    "parentName": null,
    "code": "SPLS",
    "name": "SPL Sainte-Anne 2.0"
  },
  {
    "parentName": null,
    "code": "SIEA",
    "name": "Li@in"
  },
  {
    "parentName": null,
    "code": "WAFI",
    "name": "Warndt Fibre"
  }
]